<div class="policy">
    @if (isLoading()) {
      <div class="policy-spinner">
        <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
      </div>
    }

    @if (integrationModel && policyModel) {
      <div class="policy-content">
        <div class="policy-content-header">
          <img
            (click)="backToPolicies()"
            class="back-button"
            src="assets/images/arrows/empty-arrow-left.svg"
            style="filter: invert(20%) sepia(85%) saturate(3478%) hue-rotate(256deg) brightness(89%) contrast(96%)" />
          {{ integrationModel.name }} / {{ policyModel.name }}
        </div>

        <div class="policy-content-tabs-section">
          <div class="policy-content-tabs">
            <app-sidepanel-tabs
              (tabOnSelection)="onTabSelect($event)"
              [currentTabIndex]="(currentTabIndex$ | async) ?? 0"
              [tabs]="tabs">
            </app-sidepanel-tabs>
          </div>
          <div class="divider"></div>
        </div>

        @if (!isLoading()) {
          @switch (currentTabIndex$ | async) {
            @case (0) {
              <div class="scollable-tables">
                <app-violation-rules
                  [ruleType]="RuleTypeEnum.risk"
                  (refreshRequested)="refreshPage()"
                  [integrationId]="integrationId"
                  [policyId]="policyId"
                  [violationRules]="violationRules">
                </app-violation-rules>
              </div>
            }
            @case (1) {
              <div class="scollable-tables">
                <app-violation-rules
                  [ruleType]="RuleTypeEnum.hygiene"
                  (refreshRequested)="refreshPage()"
                  [integrationId]="integrationId"
                  [policyId]="policyId"
                  [violationRules]="hygieneRules">
                </app-violation-rules>
              </div>
            }
            @case (2) {
              <div class="scollable-tables">
                <app-policy-config [environments]="environments"></app-policy-config>
              </div>
            }
            @case (3) {
              <div class="scollable-tables">
                <app-in-line-control-rules></app-in-line-control-rules>
              </div>
            }
          }
        }
      </div>
    }
  </div>